import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";

const SECTIONS = [
  {
    title: "Money",
    icon: "💰",
    items: [
      { icon: "💵", label: "Cash Pickup", path: "/cash-tracker", color: "#16a34a", desc: "Register pickups & deposits" },
      { icon: "🏧", label: "ATM Load", path: "/atm-load", color: "#7c3aed", desc: "Track ATM cash loads" },
      { icon: "📒", label: "Ledger", path: "/ledger", color: "#b45309", desc: "Expenses, payroll, taxes" },
      { icon: "🔔", label: "Reminders", path: "/reminders", color: "#e11d48", desc: "Recurring tasks" },
    ],
  },
  {
    title: "Store",
    icon: "📦",
    items: [
      { icon: "📦", label: "Inventory", path: "/inventory", color: "#dc2626", desc: "Stock & low-stock alerts" },
      { icon: "🏷️", label: "Pricebook", path: "/pricebook", color: "#d97706", desc: "Master pricing list" },
      { icon: "🆔", label: "SKU Map", path: "/sku-map", color: "#2563eb", desc: "SKU ↔ UPC" },
      { icon: "🏢", label: "Vendors", path: "/vendors", color: "#0891b2", desc: "Vendor list" },
      { icon: "📊", label: "Sales", path: "/sales", color: "#7c3aed", desc: "Revenue & top sellers" },
    ],
  },
  {
    title: "Invoices & Tools",
    icon: "🛠️",
    items: [
      { icon: "📤", label: "Upload Invoice", path: "/invoice", color: "#4f46e5", desc: "Parse PDF invoices" },
      { icon: "📋", label: "Invoices", path: "/invoice-items", color: "#0ea5e9", desc: "Browse saved invoices" },
      { icon: "🛒", label: "Import POS", path: "/pos-import", color: "#059669", desc: "Sales & pricebook import" },
      { icon: "📷", label: "Scanner", path: "/scanner", color: "#0284c7", desc: "Barcode scanner" },
      { icon: "🥤", label: "Coke Mapper", path: "/coke-mapper", color: "#ef4444", desc: "Case → item UPC" },
      { icon: "🚬", label: "Cigarette Mapper", path: "/cigarette-mapper", color: "#475569", desc: "Carton → pack UPC" },
    ],
  },
];

function HomeCard({ item }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="home-tile"
      onClick={() => navigate(item.path)}
      aria-label={item.label}
    >
      <div
        className="home-tile-icon"
        style={{ background: item.color + "1a", color: item.color }}
      >
        {item.icon}
      </div>
      <div className="home-tile-text">
        <div className="home-tile-label">{item.label}</div>
        <div className="home-tile-desc">{item.desc}</div>
      </div>
    </button>
  );
}

export default function Home() {
  return (
    <Container fluid="md" className="home-container">
      <div className="home-header">
        <h1 className="home-title">Shoolin</h1>
        <p className="home-subtitle">Manage your liquor store</p>
      </div>

      {SECTIONS.map((section) => (
        <section key={section.title} className="home-section">
          <h2 className="home-section-title">
            <span className="home-section-icon">{section.icon}</span>
            {section.title}
          </h2>
          <div className="home-grid">
            {section.items.map((item) => (
              <HomeCard key={item.path} item={item} />
            ))}
          </div>
        </section>
      ))}
    </Container>
  );
}
